import styled from 'styled-components';
export const DecorationWrapper = styled.div `
  align-items: center;
  display: flex;
  line-height: 1;

  &:first-child {
    padding-left: ${(props) => props.theme.spacing.xs};
  }

  &:last-child {
    padding-right: ${(props) => props.theme.spacing.xs};
  }
`;
